import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppContext } from '@/context/AppContext';
import Button from '@/shared/components/Button/Button';
import Stack from '@/shared/components/Stack/Stack';
import Text from '@/shared/components/Text/Text';
import DataView from '@/shared/components/DataView/DataView';
import { ItemType } from '@/types/core/Item';
import Logo from '@/shared/components/Logo/Logo';
import Topbar from '@/shared/components/Topbar/Topbar';

import './Dashboard.css';

const ITEM_TYPES: ItemType[] = ['mesh', 'light', 'effect'];

const Dashboard: FC = () => {
  const { state, createWorld } = useAppContext();
  const worlds = Object.values(state.worlds);
  const navigate = useNavigate();

  const handleCreateWorld = () => {
    const worldCount = worlds.length;
    createWorld(`World ${worldCount + 1}`);
  };

  const handleOpenPlayer = () => {
    navigate('/player');
  };

  return (
    <Stack className="dashboard" gap="no">
      <Topbar>
        <Logo />
      </Topbar> 
      <Stack className="main" direction="vertical" fill>
        <Text variant="h2">Worlds</Text>
        {worlds.length === 0 ? (
          <Text variant="p">No worlds created yet.</Text>
        ) : (
          <Stack className="worlds__grid" direction="horizontal" gap="md">
            {worlds.map(world => (
              <Link 
                key={world.id} 
                to={`/creator/${world.id}`}
                className="worlds__grid__item"
              >
                <Stack direction="vertical" gap="sm">
                  <Text variant="h3">{world.name}</Text>
                </Stack>
              </Link>
            ))}
          </Stack>
        )}
        <Stack direction="horizontal" gap="md">
          <Button onClick={handleCreateWorld}>Create World</Button>
          <Button onClick={handleOpenPlayer} disabled={worlds.length === 0}>Open Player</Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Dashboard; 